<template>
    <ion-header>
        <ion-toolbar mode="md">
            <ion-title style="font-family: 'Montserrat', sans-serif; font-weight: 700; text-align: center"
                >Property Info</ion-title
            >
        </ion-toolbar>
    </ion-header>
    <ion-content style="--background: white">
        <ion-list style="padding-right: 20px">
            <ion-item>
                <ion-label>{{ item['name'] }}</ion-label>
            </ion-item>
            <ion-item v-if="item['address']['short_name'] != null && item['address']['short_name'] != ''">
                <ion-icon :icon="locationSharp"></ion-icon>
                <ion-label>{{ item['address']['short_name'] }}</ion-label>
            </ion-item>
            <ion-item>
                <img style="max-height: 25px; margin: 10px" src="@/assets/icons/bed-icon.png" />
                <span style="margin-right: 10px">{{ item['bedrooms'] }}</span>
                <img style="max-height: 25px; margin: 10px" src="@/assets/icons/bath-icon.png" />
                <span style="margin-right: 10px">{{ item['baths'] }}</span>
                <img style="max-height: 25px; margin: 10px" src="@/assets/icons/guest-icon.png" />
                <span style="margin-right: 10px">{{ item['max_guests'] }}</span>
                <img
                    style="max-height: 25px; margin: 10px"
                    v-if="item['pets_allowed']"
                    src="@/assets/icons/pet-icon.png"
                />
                <img style="max-height: 25px; margin: 10px" v-else src="@/assets/icons/nopet-icon.png" />
            </ion-item>
        </ion-list>
        <div style="padding-bottom: 200px"></div>
    </ion-content>

    <ion-grid class="ldx-bottom-fixed" style="padding: 0px; margin: 0px">
        <ion-row style="padding: 0px">
            <ion-col style="padding: 0px">
                <ion-button
                    style="width: 100%; height: 100%; margin: 0px"
                    expand="full"
                    color="danger"
                    @click="cancel()"
                    >Back</ion-button
                >
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script lang="ts">
    import { modalController } from '@ionic/vue';
    import { defineComponent } from 'vue';
    import {
        searchOutline,
        locationSharp,
        checkmarkCircleOutline,
        closeCircleOutline,
        informationCircleOutline,
    } from 'ionicons/icons';

    export default defineComponent({
        props: ['item'],
        name: 'PropModal',
        components: {},
        setup() {
            const cancel = () => {
                return modalController.dismiss(
                    {
                        //
                    },
                    'cancel'
                );
            };

            return {
                searchOutline,
                locationSharp,
                checkmarkCircleOutline,
                closeCircleOutline,
                informationCircleOutline,
                cancel,
            };
        },
    });
</script>

<style scoped>
    .ldx-reservation-form ion-item::part(native) {
        background: var(--ion-color-light-tint);
        border: 1px solid var(--ion-color-medium-tint);
        border-radius: 0.25rem;
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
        margin-bottom: 0.75rem;
    }

    .ldx-reservation-form ion-label {
        margin: 0;
    }

    .ldx-reservation-form ion-icon {
        font-size: 14px;
    }

    .ldx-reservation-form .select-icon {
        right: 1.5rem;
        position: absolute;
    }

    .ldx-reservation-form ion-select::part(placeholder),
    .ldx-reservation-form ion-select::part(text),
    .ldx-reservation-form ion-select::part(icon) {
        color: #000000;
        opacity: 1;
    }

    .ldx-reservation-form ion-select::part(icon) {
        right: 1.5rem;
        position: absolute;
    }

    .ldx-reservation-form ion-icon.ldx-alt-icon {
        background: var(--ion-color-primary);
        color: #ffffff;
        padding: 0.5rem;
        font-size: 15px;
        border-radius: 5px;
        margin: 0;
    }
</style>
